import {createSelector} from 'reselect';
import {getErrors, getSuccess, getAlertType} from '../../App/selectors';

export const errorSelector = createSelector([getErrors], error => error);
export const successSelector = createSelector([getSuccess], success => success);
export const selectAlertType = createSelector([getAlertType], type => type);
